import React, { useEffect, useState } from 'react'
import { styled } from '@mui/system';
import ExpInput from './ExpInput';
import { Typography } from '@mui/material';
import { Dialog } from '@mui/material';
import { activitiesDATA } from '../Activity/AddActivity';
import TableExpComponent from '../TableComponent/TableExpComponent';
import { remove, ref } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';
import { db, auth } from '../../firebase';

const MainContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});
const UserDet = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '15px',
    border: '1px solid #D8D0D0',
    borderRadius: '12px',
    width: '90%',
});
const GenerateButton = styled('button')({
    marginTop: '20px',
    backgroundColor: '#2560CD',
    padding: '10px 26px',
    color: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    cursor: 'pointer',
    borderRadius: '10px',
    '&:hover': {
        background: 'black',
        color: 'white',
        transform: 'scale(1.1)',
    },
});

let expLevel, expEnjoy, expOutcome;
let name, overallData;

const AddExp = ({ data, setData, handlePrevious, handleNextClick, validationError }) => {
    const [showDialog, setShowDialog] = React.useState(false);
    const [userUid, setUserUid] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setUserUid(user.uid);
            } else {
                setUserUid(null);
            }
        });

        return () => {
            unsubscribe();
        };
    }, []);
    const handleAddButtonClick = () => {
        setShowDialog(true);
    };

    const handleActivityDelete = async (index) => {
        const newData = [...data];
        newData.splice(index, 1);
        setData(newData);
        try {
            const expDetailsRef = ref(db, `Users/${userUid}/expDetails/${index}`);
            await remove(expDetailsRef);
            const newData = [...data];
            newData.splice(index, 1);
            setData(newData);
        } catch (error) {
            console.error('Error deleting activity:', error);
        }
    };

    const handleActivitySave = (activity) => {
        setData(prevActivities => [...prevActivities, activity]);
        setShowDialog(false);
    };

    const handleActivityCancel = () => {
        setShowDialog(false);
    };

    expLevel = data.map(obj => obj.level);
    expEnjoy = data.map(obj => obj.enjoyment);
    expOutcome = data.map(obj => obj.outcome);
    name = data.map(obj => obj.company);
    if (activitiesDATA.length > 0) {
        overallData = activitiesDATA.concat(name)
    }

    return (
        <MainContainer>
            <div style={{ display: 'flex', alignItems: 'flex-start', width: '91%' }}>
                <Typography color='black' style={{
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 600,
                    fontSize: '20px'
                }}>
                    Professional Experience
                </Typography>
            </div>
            <UserDet>
                {data.length === 0 && (<div>
                    <Typography style={{
                        fontSize: '14px',
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                    }}>
                        Please include all details about your work experiences and internships, encompassing roles, responsibilities, and any other forms of
                        professional involvement beyond your academic pursuits.
                    </Typography>
                </div>)}
                {data.length > 0 && (
                    <TableExpComponent data={data} onDelete={handleActivityDelete} />
                )}
                <GenerateButton onClick={handleAddButtonClick}>
                    Add Experience
                </GenerateButton>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <GenerateButton
                        onClick={handlePrevious}
                    >
                        Previous
                    </GenerateButton>
                    {validationError && <p style={{ color: 'red', marginTop: '10px', textAlign: 'center' }}>{validationError}</p>}
                    <GenerateButton
                        onClick={handleNextClick}
                    >
                        Next
                    </GenerateButton>
                </div>
                <Dialog open={showDialog} onClose={() => setShowDialog(false)} PaperProps={{
                    style: {
                        minWidth: '58%', position: 'absolute',
                        top: '45%',
                        left: '58%',
                        transform: 'translate(-50%, -50%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '12px'
                    }
                }}>
                    <ExpInput onSave={handleActivitySave} onCancel={handleActivityCancel} />
                </Dialog>
            </UserDet>
        </MainContainer>
    )
}

export { expEnjoy, expLevel, expOutcome, overallData }
export default AddExp;